import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.promise.finally";
import * as products from './products';
import { selectActiveProduct } from './Products.reducer';
export var getActiveProduct = function getActiveProduct(state) {
  var _selectActiveProduct = selectActiveProduct(state),
      key = _selectActiveProduct.key;

  return products[key];
};
export var activateProductOnEnter = function activateProductOnEnter(store, Product, dataMapper) {
  return function (_ref, replaceState, cb) {
    var params = _ref.params;
    return store.runSagaOnce(Product.activate.bind(Product), dataMapper(params)).done.finally(cb);
  };
};